enum ActionType {
    REQUEST_ROLES_FOR_CURRENT_USER = ' [CORE/ROLES] SET ROLES FOR CURRENT',
    RECEIVE_ROLES_FOR_CURRENT_USER = ' [CORE/ROLES] SET ROLES RECEIVE FOR CURRENT',
}

export default ActionType
